import { TopNavigation } from "components/navigations";
import { FC, useState } from "react";

import { LayoutProps } from "./Layout.types";

export const GetStartedLayout: FC<LayoutProps & { id?: string }> = ({ children, bgColor, id = "" }) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  return (
    <main
      className={`w-full h-screen ${bgColor} overflow-auto pb-20`}
      onScroll={e => setScrollPosition(e.currentTarget.scrollTop)}
      id={id}
    >
      <TopNavigation shadow={scrollPosition > 0} />
      {children}
    </main>
  );
};
